export default "__VITE_PUBLIC_ASSET__2659da05__"